import { render, staticRenderFns } from "./ReportsHome.vue?vue&type=template&id=460b298e"
import script from "./ReportsHome.vue?vue&type=script&lang=js"
export * from "./ReportsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports